<template>
  <div id="footer" class="container-fluid">
    <div class="foot-top hidden-xs">
      <div class="foot-top__left">
        <img class="foot-top__qrcode" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/qrcode.png">
        <div class="foot-top__concat">
          <div class="foot-top__concat-title fs-26">
            Contact Us
          </div>
          <div class="foot-top__other-info fs-18">
            <div class="foot-top__line">Room 1101-1104, Xinmao Building, No. 233 Taicang Road, Huangpu District, Shanghai, China.</div>
            <div class="foot-top__line">Tel：400-000-3395 </div>
            <div class="foot-top__line">E-mail：info@growim.com</div>
            <div class="foot-top__concat-tips">Welcome to follow GROW WeChat Account</div>
          </div>
        </div>
      </div>
      <img class="foot-top__logo" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/logo.png">
    </div>

    <div class="foot-top visible-xs">
      <div class="foot-top__left">

        <div class="foot-top__concat">
          <div class="foot-top__concat-title fs-26">
            Contact Us
          </div>
          <div class="foot-top__other-info fs-18">
            <div class="foot-top__line">Room 1101-1104, Xinmao Building, No. 233 Taicang Road, Huangpu District, Shanghai, China.</div>
            <div class="foot-top__line">Tel：400-000-3395 </div>
            <div class="foot-top__line">E-mail：info@growim.com</div>
            <div class="foot-top__concat-tips">Welcome to follow GROW WeChat Account</div>
          </div>
        </div>
        <img class="foot-top__qrcode" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/qrcode.png"></img>
      </div>
      <!-- <img class="foot-top__logo" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/logo.png"> -->
    </div>
    <div class="foot-bottom">
      <div class="foot-bottom__friend-link fs-18">
        <div>LINKS：</div>
        <div class="foot-bottom__link-list">
          <a class="foot-bottom__link-item" href="http://www.sirui-fund.com" target="_blank">SIRUI FUND</a>
          <a class="foot-bottom__link-item" href="https://taifuapp.sirui-fund.com" target="_blank">TAIFU</a>
          <!-- <a class="foot-bottom__link-item">思睿投资</a> -->
        </div>
      </div>
      <p class="address_tel_fax">
        <span class="foot-bottom__tips">The copyright and any other rights of all materials contained in this website are owned by GROW Investment Group. Any reprint,compilation,rebroadcast is strictly prohibited unless agreed to in writing by GROW.</span>
      </p>
      <p class="copy">Copyright<span style="font-size: 12px;"> © </span>思睿寰宇集团有限公司版权所有</p>
      <p class="copy">备案号：<a href="http://www.beian.miit.gov.cn" target="_blank" style="color: #fff">沪ICP备2021029188号-1</a></p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>

<style scoped>
#footer {
  padding: 0;
}
.foot-bottom {
  padding: 18px 0 21px 0;
  background: #172B53;
}

.foot-top {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  border: 2px solid #172B52;
  padding: 16px 19px;
  border-bottom: 0;
}

.foot-top__left {
  flex: 1;
  display: flex;
  margin-left: 20px;
}

.foot-top__qrcode {
   width: 132px;
   height: 132px;
   margin-right: 20px;
   margin-top: 10px;
}

.foot-top__concat {
  text-align: left;
}

.foot-top__concat-title {
  margin-top: 12px;
  font-weight: bold;
  color: #3E3A39;
}

.foot-top__other-info {
  margin-top: 12px;
  color: #3E3A39;
  line-height: 24px;
}

.foot-top__concat-tips {
  font-weight: bold;
}

.foot-top__logo {
  width: 195px;
  align-self: center;
  margin-right: 40px;
}

.foot-bottom__tips {
  display: inline-block;
  width: 680px;
}

.foot-bottom__friend-link {
  font-weight: bold;
  color: #FFFFFF;
  line-height: 28px;
}

.foot-bottom__link-list {
  display: flex;
  justify-content: center;
  margin-bottom: 17px;
}

.foot-bottom__link-item {
  margin-right: 10px;
  position: relative;
  color: #fff;
  cursor: pointer;
  text-decoration:none;
}

.foot-bottom__link-item:hover {
  color: #EB9A6A;
}

.foot-bottom__link-item:hover::after {
  background-color: #EB9A6A;
}

.foot-bottom__link-item::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  height: 3px;
  width: 100%;
  background-color: #7C879E;
}
</style>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
  text-align: center;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  /* margin: 50px 0 10px; */
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {

    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>


<style scoped>
@media screen and (max-width: 768px) {
  .foot-bottom__tips {
    width: 100% !important;
    padding: 0 10px;
  }

  .foot-top__left {
    flex-direction: column;
    align-items: center;
  }

  .foot-top__qrcode {
   width: 80px;
   height: 80px;
   margin-right: 0;
   margin-top: 10px;
}

  .foot-top {
    width: 100%;
    border: none;
  }

  .foot-top__concat {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue